import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const FetalDeathChartsDataContext = createContext();

const FetalDeathChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.FETAL_DEATH_MORTALITY,
            url: 'governanceroom/dashboard/vitalstatistics/mortality/fetal-death',
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  fetalDeaths: data?.indicators?.fetalDeaths ?? 0
              },
              deathsInRelationToChildbirth: data?.deathsInRelationToChildbirth ?? [],
              ageGroup: data?.ageGroup ?? [],
              weight: data?.weight ?? [],
              typesOfPregnancy: data?.typesOfPregnancy ?? [],
              pregnancyMonths: data?.pregnancyMonths ?? [],
              motherAge: data?.motherAge ?? []
          }
        : {
              indicators: {
                  fetalDeaths: 0
              },
              deathsInRelationToChildbirth: [],
              ageGroup: [],
              weight: [],
              typesOfPregnancy: [],
              pregnancyMonths: [],
              motherAge: []
          };

    return (
        <FetalDeathChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </FetalDeathChartsDataContext.Provider>
    );
};

export default FetalDeathChartsDataProvider;
